import React, { useEffect, useState } from "react";
import "./myEvent.scss";

import SearchInput from "../../components/searchInput/SearchInput";
import HeaderBar from "../../components/headerBar/HeaderBar";
import CardEvent from "../../components/cardEvent/CardEvent";
import VoidSpace from "../../components/voidSpace/VoidSpace";

import { t } from "i18next";
import { getFutureProgramWS } from "./api/myEventApi";
import { isEmpty } from "../../utils/validation";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";

const MyEvent = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const [listEvent, setListEvent] = useState([]);
  const [filteredListEvent, setFilteredListEvent] = useState([]);

  const searchFunction = () => {
    if (!isEmpty(search)) {
      setFilteredListEvent(
        listEvent.filter((event) => {
          const name = event.name?.toLowerCase() || "";
          const address = event.address?.toLowerCase() || "";
          const startDate = event.start_date?.toLowerCase?.() || "";

          return (
            name.includes(search.toLowerCase()) ||
            address.includes(search.toLowerCase()) ||
            startDate.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilteredListEvent(listEvent);
    }
  };

  useEffect(() => {
    getFutureProgramWS()
      .then((res) => {
        setListEvent(res.events);
        setFilteredListEvent(res.events);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <>
      <HeaderBar back={true} title={t("my_event.title")} />
      <div className="my-event-container container-responsive">
        <SearchInput
          search={search}
          setSearch={setSearch}
          searchFunction={searchFunction}
        />
        <div className="list-events-or-shift w-100 mt-3">
          <Row sm={1} md={1} lg={2} xl={3} className="g-2">
            {!isEmpty(filteredListEvent)
              ? Object.entries(filteredListEvent).map(([key, item]) => (
                  <Col sm={12} md={12} lg={6} xl={4} key={item.id}>
                    <CardEvent
                      id={item.id}
                      title={item.name}
                      associationName={item.info_association.name}
                      eventAddress={item.address}
                      photo={item.photo ? item.photo[0] : "/no_img.png"}
                      startDatetime={item.start_date}
                      viewLike={false}
                      history={!!item.terminated}
                    />
                  </Col>
                ))
              : null}
          </Row>
        </div>
        <VoidSpace />
      </div>
    </>
  );
};

export default MyEvent;
